import { ProductWasteStatistics } from "../../../models/Statistics";

export const REQUEST_STOREWASTESTATISTICS_BY_PRODUCT =
  "REQUEST_STOREWASTESTATISTICS_BY_PRODUCT";
export const REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE =
  "REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE";

export interface FetchStoreWasteByProductStatistics {
  type: typeof REQUEST_STOREWASTESTATISTICS_BY_PRODUCT;
  payload: ReadonlyArray<ProductWasteStatistics>;
}

export interface FetchStoreWasteByProductStatisticsDone {
  type: typeof REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE;
  payload: ReadonlyArray<ProductWasteStatistics>;
}

export interface ProductWasteStatisticsState {
  isLoading: boolean;
  productWasteStatistics: ReadonlyArray<ProductWasteStatistics>;
}

export type ProductWasteStatisticsActions =
  | FetchStoreWasteByProductStatistics
  | FetchStoreWasteByProductStatisticsDone;
